// src/helpers/color.ts
var adjustShade = (color, amount) => {
  return color.replace(
    /\w\w/g,
    (m) => Math.min(255, Math.max(0, parseInt(m, 16) + amount)).toString(16)
  );
};

export { adjustShade };
